import * as elIcons from '@element-plus/icons-vue'
import Icon from '@/components/Icon/index.vue'
import SvgIcon from '@/components/SvgIcon/index.vue'

export function registerIcons (app) {
  // 全局注册 Icon
  app.component('Icon', Icon)

  // 全局注册element Plus的icon
  const icons = elIcons
  for (const i in icons) {
    app.component(`el-icon-${icons[i].name}`, icons[i])
  }
}

export function registerSvgIconIcons (app) {
  // 全局注册 SvgIcon
  app.component('SvgIcon', SvgIcon)
}

/**
 * 是否是外部链接
 * @param path
 */
export function isExternal (path) {
  return /^(https?|ftp|mailto|tel):/.test(path)
}

/**
 * 切换静态资源地址
 */
export const changeHttps = (url) => {
  return url.replace(/^https?:/, '')
}

/**
 * 新增顺序_index
 */
export const addIndex = (list, index = 0) => {
  list.forEach(c => {
    if (c.children && c.children.length) {
      addIndex(c.children, index + 1)
    }
    c._index = index
  })
}

/**
 * 数字转为汉字
 */
const units = '个十百千万@#%亿^&~'
const chars = '零一二三四五六七八九'

export const NumberToChinese = function (number) {
  const a = (number + '').split('')
  const s = []
  if (a.length > 12) {
    throw new Error('too big')
  } else {
    // eslint-disable-next-line no-var
    for (var i = 0, j = a.length - 1; i <= j; i++) {
      if (j === 1 || j === 5 || j === 9) {
        // 两位数 处理特殊的 1*
        if (i === 0) {
          if (a[i] !== '1') s.push(chars.charAt(a[i]))
        } else {
          s.push(chars.charAt(a[i]))
        }
      } else {
        s.push(chars.charAt(a[i]))
      }
      if (i !== j) {
        s.push(units.charAt(j - i))
      }
    }
  }
  return s
    .join('')
    .replace(/零([十百千万亿@#%^&~])/g, function (m, d, b) {
    // 优先处理 零百 零千 等
      b = units.indexOf(d)
      if (b !== -1) {
        if (d === '亿') return d
        if (d === '万') return d
        if (a[j - b] === '0') return '零'
      }
      return ''
    })
    .replace(/零+/g, '零')
    .replace(/零([万亿])/g, function (m, b) {
    // 零百 零千处理后 可能出现 零零相连的 再处理结尾为零的
      return b
    })
    .replace(/亿[万千百]/g, '亿')
    .replace(/[零]$/, '')
    .replace(/[@#%^&~]/g, function (m) {
      return {
        '@': '十',
        '#': '百',
        '%': '千',
        '^': '十',
        '&': '百',
        '~': '千'
      }[m]
    })
    .replace(/([亿万])([一-九])/g, function (m, d, b, c) {
      c = units.indexOf(d)
      if (c !== -1) {
        if (a[j - c] === '0') return d + '零' + b
      }
      return m
    })
}

/**
 * 图片预览地址
 */
export const getImgUrl = (id) => `${process.env.VUE_APP_PREVIEW_HOST}/file-center/preview/url/ret?id=${id}`
